module.exports = __webpack_public_path__ + "img/BY.019f1682.png";